import React from "react";
import {usePrePlanOptions} from "./hooks/usePrePlanOptions";
import {IconDispute, IconLink} from "@bounce/shared/ui";
import {IconVerification} from "@bounce/shared/consumer/bounce-ui";
import {CustomMenuItem, MenuItemDivider} from "@bounce/shared/consumer/components";

const PrePlanOptions = () => {
  const {
    shouldDisplayPrePlanOptions,
    onContributionLinkClick,
    onDisputeClick,
    isDisputeButtonDisabled,
    onVerificationRequestClick,
  } = usePrePlanOptions();

  if (!shouldDisplayPrePlanOptions) return null;

  return (
    <>
      <CustomMenuItem
        onClick={onContributionLinkClick}
        label="Share contribution link"
        icon={<IconLink width={20} height={20} />}
      />
      <CustomMenuItem
        onClick={onVerificationRequestClick}
        label="Request debt verification"
        icon={<IconVerification width={20} height={20} />}
      />
      <CustomMenuItem
        onClick={onDisputeClick}
        label="Dispute This Debt"
        icon={<IconDispute width={20} height={20} />}
        disabled={isDisputeButtonDisabled}
      />
      <MenuItemDivider />
    </>
  );
};

export default PrePlanOptions;
